<template>
    <div>
        <p v-if="!$isMyBeauty" class="text pb-3 mb-3 pt-3 mt-3">
            By registering you agree to accept the
            <a href="https://www.harrods.com/en-gb/legal/terms-and-conditions" target="_blank"><span class="hyperlink">Terms & Conditions</span></a>,
            <a href="https://www.harrods.com/en-gb/legal/harrods-rewards" target="_blank"><span class="hyperlink">Harrods Rewards Terms & Conditions</span></a>,
            and have read the
            <a href="https://www.harrods.com/en-gb/legal/privacy-policy" target="_blank"><span class="hyperlink">Privacy Policy.</span></a>
        </p>
        <p v-else class="text pb-3 mb-3 pt-3 mt-3">
            By registering you agree to accept the
            <a href="https://www.harrods.com/en-gb/legal/my-beauty" target="_blank"><span class="hyperlink">Harrods Rewards Terms & Conditions</span></a>,
            the
            <a href="https://www.harrods.com/en-gb/legal/harrods-rewards" target="_blank"><span class="hyperlink">MyBeauty Terms & Conditions</span></a>
            and have read the
            <a href="https://www.harrods.com/en-gb/legal/privacy-policy" target="_blank"><span class="hyperlink">Privacy Policy.</span></a>
        </p>
        <p class="text pb-3 mb-5">
            You can unsubscribe from the Harrods Rewards Programme at any time or enquire about how we use your personal data by contacting our Customer Service team on
            <a class="hyperlink" href="tel:+442077301234">+44 (0)20 7730 1234</a>
            or email
            <a class="hyperlink" href="mailto:customer.service@harrods.com">customer.service@harrods.com</a>.
        </p>
    </div>
</template>

<script setup>
    // No logic needed for this stateless component.
    // If you want to access $isMyBeauty as a prop or via inject, you can add that here.
    // Example if you want to inject it:
    // import { inject } from 'vue'
    // const isMyBeauty = inject('$isMyBeauty', false)
</script>

<style lang="scss" scoped>
    .text {
        font-size: 14px;
    }

    .hyperlink {
        font-size: 14px;
    }
</style>
